import React from 'react'
import { useAction } from '../utils/react-redux'
import { setAmbiguityAddress } from '../../store/location/location.actions'
import s from './AddressItem.less'
import useEventCallback from '../utils/useEventCallback'

const AddressItem = ({ address }) => {
  const execSetAddress = useAction(setAmbiguityAddress)
  const [firstLabel, ...otherLabels] = address.split_label

  const onClick = useEventCallback(() => {
    execSetAddress(address)
  }, [execSetAddress])

  return (
    <div onClick={onClick}>
      <h1 className={s.AddressItem_link}>
        <a href={`/plan/${address.label}`}>
          <span className={s.AddressItem_mainLabel}>{firstLabel}</span>
          <span className={s.AddressItem_secondaryLabel}>
            {otherLabels.map((label, id) => (
              <span key={id}>{label}</span>
            ))}
          </span>
        </a>
      </h1>
    </div>
  )
}

export default AddressItem
